import { useState, useEffect } from "react";
import { UseFormSetValue } from "react-hook-form";
import { type CreateCampaignRouletteFormData } from "../../validations/campaign-roulette.validation";

export const useBannerState = (
  setValue: UseFormSetValue<CreateCampaignRouletteFormData>
) => {
  const [banner3x4Preview, setBanner3x4Preview] = useState<string | null>(null);
  const [banner16x9Preview, setBanner16x9Preview] = useState<string | null>(null);

  const handleBanner3x4Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setValue("banner3x4", file);
      if (banner3x4Preview) {
        URL.revokeObjectURL(banner3x4Preview);
      }
      const objectUrl = URL.createObjectURL(file);
      setBanner3x4Preview(objectUrl);
    }
  };

  const handleBanner16x9Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setValue("banner16x9", file);
      if (banner16x9Preview) {
        URL.revokeObjectURL(banner16x9Preview);
      }
      const objectUrl = URL.createObjectURL(file);
      setBanner16x9Preview(objectUrl);
    }
  };

  const removeBanner3x4 = () => {
    setValue("banner3x4", undefined as unknown as File);
    if (banner3x4Preview) {
      URL.revokeObjectURL(banner3x4Preview);
    }
    setBanner3x4Preview(null);
  };

  const removeBanner16x9 = () => {
    setValue("banner16x9", undefined as unknown as File);
    if (banner16x9Preview) {
      URL.revokeObjectURL(banner16x9Preview);
    }
    setBanner16x9Preview(null);
  };

  useEffect(() => {
    return () => {
      if (banner3x4Preview) {
        URL.revokeObjectURL(banner3x4Preview);
      }
      if (banner16x9Preview) {
        URL.revokeObjectURL(banner16x9Preview);
      }
    };
  }, [banner3x4Preview, banner16x9Preview]);

  return {
    banner3x4Preview,
    banner16x9Preview,
    handleBanner3x4Change,
    handleBanner16x9Change,
    removeBanner3x4,
    removeBanner16x9,
  };
};
